import AccessibilityHelper from '../lib/AccessibilityHelper.js';
export default {
    dependencies: ['$element'],
    callable(ele) {
        function toggleText(text) {
            if (text) {
                ele.setAttribute('data-toggle-text', ele.textContent);
                ele.textContent = text;
            }
        }
        function ariaToggle(target) {
            const isVisible = !(
                target.classList.contains('hidden') ||
                target.classList.contains('u-display-none')
            );
            if (isVisible) {
                target.classList.add('hidden', 'u-display-none');
                target.removeAttribute('aria-hidden');
                AccessibilityHelper.focusFirst(target);
            } else {
                target.classList.remove('hidden', 'u-display-none');
                target.setAttribute('aria-hidden', 'true');
                ele.focus();
            }
            return target;
        }
        function openToggleDialog() {
            Array.from(
                document.querySelectorAll(
                    `[${ele.getAttribute('data-select')}]`
                )
            ).forEach(ariaToggle);
            toggleText(ele.getAttribute('data-toggle-text'));
        }
        function goToLogin(href, content) {
            window.sessionStorage.setItem('open-toggle-dialog', content);
            window.location = href;
        }
        if (
            window.sessionStorage.getItem('open-toggle-dialog') ===
            ele.getAttribute('data-select')
        ) {
            window.sessionStorage.removeItem('open-toggle-dialog');
            openToggleDialog();
        }
        ele.addEventListener('click', evt => {
            evt.preventDefault();
            const { href } = ele;
            if (href && href.includes('login')) {
                const content = ele.getAttribute('data-select');
                goToLogin(href, content);
            } else {
                openToggleDialog();
            }
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/toggleContent.js